import React from "react";
import { View } from "react-native";

type Message2Props = {
  color?: string;
};

const Message2: React.FC<Message2Props> = ({ color = "black" }) => {
  return (
    <View>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_15894_1225)">
          <path
            d="M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H14V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_15894_1225">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </View>
  );
};

export default Message2;
